import React from 'react'

import "../../assets/css/main.css"
import "./nf.css"

export default function NotFound() {
    return (
        <div className="notfound">
            <div className="notfound_content">
                <h1>
                    Not Found
                </h1>
            </div>
        </div>
    )
}